import React from 'react';
import './Banner.css'; // Separate CSS file for banner styles

const Banner: React.FC = () => {
  return (
    <div className="banner">
      <h2 className="banner-text"> Produsele care nu sunt în stoc, se pot realiza pe bază de comandă.</h2>
    </div>
  );
};

export default Banner;
